import {
  DriverLocationEntity,
  GeoCoord,
  LocationHistoryEvent,
  ShiftEntity,
  TransportEntity
} from "@ots-frontend/ots-data";
import * as CSS from 'csstype';
import {BBox} from "@turf/turf";

export const DEFAULT_LOCATION_HISTORY_MAP_FILTER: LocationHistoryMapFilter = {
  showSites: true,
  showGeofenceEvents: true,
  showTransportRoutes: true,
  showDriverLocationRoute: false,
  showDriverLocations: false,
  selectedTransportIds: undefined,
}

export interface LocationHistoryMapFilter {
  showSites: boolean;
  showDriverLocations: boolean;
  showDriverLocationRoute: boolean;
  showGeofenceEvents: boolean;
  showTransportRoutes: boolean;
  selectedShiftId?: string;
  selectedTransportIds?: string[];
}

export type TransportRoute = {
  transport: TransportEntity;
  route: GeoCoord[];
  driverLocations: DriverLocationEntity[]
  color: CSS.Property.Color;
};

export type ShiftLocationHistory = {
  shift: ShiftEntity;
  events: Map<number, LocationHistoryEvent>;
  transportRoutes: TransportRoute[];
  driverLocations: DriverLocationEntity[]
  // reference metadata
  transportIds: string[];
  minDttm?: number;
  maxDttm?: number;
  bbox?: BBox
};


